import { AuthService } from '../shared-components/ng-login/auth/auth.service';
import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogoutBeforeSelector implements CanActivate {

  constructor(private authService: AuthService) {
  }

  canActivate(): boolean {
    this.authService.logout();

    return true;
  }

}
